import type { SelectorObj } from '../../shared.types'
import { getVariantSelectors, variantsComparator } from '../../utils/variantsUtils'
import type { DomApplier } from '../cssFeatures.types'

export const imageXScrollEffectsDomApplier: DomApplier<'imageXScrollEffects'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ imageXScrollEffects },
	accumulatedData
) => {
	const data = imageXScrollEffects?.data
	const variants = imageXScrollEffects?.variants || null

	if (!data) {
		return null
	}

	const cssInBreakpoint = data?.[breakpointId]
	if (!cssInBreakpoint) {
		return null
	}

	return Object.entries(cssInBreakpoint)
		.sort(variantsComparator(variants!))
		.reduce<SelectorObj>((acc, [variantKey, cssObj]) => {
			if (!cssObj) {
				return acc
			}

			const variantSelectors = getVariantSelectors(variantKey, variants, compId, accumulatedData)

			for (const element in cssObj) {
				const finalSelector = `${variantSelectors} ${element}`
				acc[finalSelector] = Object.assign(acc[finalSelector] || {}, cssObj[element])
			}
			return acc
		}, {})
}
